import { SearchFiltersDropdown } from '../../components/search-filters-dropdown/search-filters-dropdown'
import { FacetName, FilterName } from '../../__generated__/fed-graphql-types'
import { withFilterContext } from '../hocs/filter.context.hoc'
import { withFacetContext } from '../hocs/facet.context.hoc'

export const FuelConsumption = withFacetContext(
    FacetName.fuel_consumption_values,
    withFilterContext(FilterName.fuel_consumption_values, SearchFiltersDropdown, {
        title: 'Fuel consumption',
        hideLabel: true,
    })
)
